import { isValidForCurrentTime } from "helpers/utils/util";
import {
  CategoryBarData,
  SubCategoryBarOptions,
  SubSubCategoryBarOptions,
} from 'shared/types/product/Category';

export const isValidCategoryType = (obj: { type?: string, link?: string } | null | undefined): boolean => {
  const validTypes = new Set(["link", "page-folder"]);
  if (obj?.type?.toLowerCase() == 'link') {
    return validTypes.has(obj?.type ?? "") && Boolean(obj.link && obj.link.length > 0);
  }
  return validTypes.has(obj?.type ?? "");
};

const filterVisibleL3Categories = (
  categories: SubSubCategoryBarOptions[] = [],
): SubSubCategoryBarOptions[] => {
  return categories.filter((category) =>
    isValidForCurrentTime(category.validFrom, category.validTo),
  );
};

const filterVisibleL2Categories = (
  categories: SubCategoryBarOptions[] = [],
): SubCategoryBarOptions[] => {
  return categories
    .filter((category) =>
      isValidForCurrentTime(category.validFrom, category.validTo),
    )
    .map((category) => ({
      ...category,
      subSubCategoryOptions: filterVisibleL3Categories(
        category.subSubCategoryOptions,
      ),
    }));
};

export const filterVisibleCategories = (
  categories: CategoryBarData[] = [],
): CategoryBarData[] => {
  return categories
    .filter((category) =>
      isValidForCurrentTime(category.validFrom, category.validTo),
    )
    .map((category) => ({
      ...category,
      subcategoryOptions: filterVisibleL2Categories(
        category.subcategoryOptions,
      ),
    }));
};